import { WorkstationSlotStatus } from '@navio/nsdk';
import type { BadgeVariant } from 'noddi-ui-web';

export const WORKSTATION_SLOT_STATUS_BADGE_VARIANT: Record<WorkstationSlotStatus, BadgeVariant> = {
  [WorkstationSlotStatus.BOOKED]: 'success',
  // Partner UI overrides this with green→yellow classes for external demand;
  // success keeps a green base when no override is applied.
  [WorkstationSlotStatus.BOOKING_EXTERNAL]: 'success',
  [WorkstationSlotStatus.RESERVED]: 'info',
  [WorkstationSlotStatus.BLOCKED]: 'outline'
};
